export enum BookingApproveFormFieldsEnum {
  APPROVAL_REASON_CATEGORY = "approvalReasonCategory",
  APPROVAL_REASON_ID = "approvalReasonId",
  APPROVER = "approver",
}
